import { useEffect, useState } from "react";
import Stream from "pages/Stream";
import Transaction from "pages/Transaction";
import { Offcanvas } from "react-bootstrap";
import { erc20ABI, useAccount } from "wagmi";
import { ethers } from "ethers";
import { ceil } from "lodash";
import { icons } from "utils/constants";
import { useSelector } from "react-redux";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import "./TransactionAndStream.scss";

const TransactionAndStream = () => {
  const reduxData = useSelector((state) => state.global);
  const { globalChainID, isDarkMode } = reduxData;
  const accountData = useAccount();
  const { address } = accountData;
  const [show, setShow] = useState(false);
  const [tokenBalance, setTokenBalance] = useState(0);

  const getPageData = async () => {
    try {
      if ([1, 11155111, 137].includes(globalChainID)) {
        const tokenADDRESS =
          globalChainID === 1
            ? "0x479347dfd0be56f2a5f7bb1506bfd7ab24d4ba26"
            : globalChainID === 137
            ? "0xf1e073d53AF781966F23B1a3B2D9E67cbbA69B92"
            : "0xAfE70A1985ebDefbDCaeedba045d66091C38E1B1";
        const walletADDRESS = address?.toLowerCase();
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const tokenContract = new ethers.Contract(
          tokenADDRESS,
          erc20ABI,
          provider.getSigner()
        );
        if (tokenContract) {
          const userBalance = await tokenContract?.balanceOf(walletADDRESS);
          if (globalChainID === 1 || globalChainID === 137) {
            const balanceInToken = ethers?.utils?.formatUnits(
              userBalance,
              "ether"
            );
            let fBalance =
              +balanceInToken > 0
                ? (Math.round(balanceInToken * 100) / 100).toFixed(2)
                : 0;
            setTokenBalance(fBalance);
          } else if (globalChainID === 11155111) {
            const balanceInToken = ethers?.utils?.formatUnits(
              userBalance,
              "gwei"
            );
            setTokenBalance(ceil(balanceInToken));
          } else {
            // Nothing
          }
        }
      } else {
        setTokenBalance(0);
      }
    } catch (error) {
      console.log("✌️error --->", error);
    }
  };

  useEffect(() => {
    getPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, globalChainID]);

  let gAPIUrl = "";
  if (globalChainID === 1) {
    gAPIUrl = "https://eth-mainnet.subgraph.x.superfluid.dev/";
  }
  if (globalChainID === 11155111) {
    gAPIUrl =
      "https://subgraph.satsuma-prod.com/c5br3jaVlJI6/superfluid/eth-sepolia/api";
  }
  if (globalChainID === 137) {
    gAPIUrl =
      "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-matic";
  }
  const client = new ApolloClient({
    uri: gAPIUrl,
    cache: new InMemoryCache(),
  });

  return (
    <div id="transactionandstream-container">
      <Transaction setShow={setShow} tokenBalance={tokenBalance} />
      <Offcanvas
        show={show}
        onHide={() => {
          setShow(false);
        }}
        key="1"
        placement="end"
        name="end"
        className={isDarkMode ? "dark-offcanvas" : ""}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="w-100">
            <div className="fa-center">
              <div
                className={`text-26-600 ${
                  isDarkMode ? "color-ffff" : "color-2749"
                } cme-60`}
              >
                Streams
              </div>
              {/* <div className="text-26-600 color-2749 cme-60" onClick={() => deleteStream()}>Delete</div> */}
              <div
                className="fa-center gap-2 shadow b-e3e3 pointer cps-20 cpe-20 cpt-10 cpb-10 br-10 un"
                onClick={() => {
                  if (globalChainID === 1) {
                    window.open(
                      "https://app.superfluid.finance/token/ethereum/0x479347dfd0be56f2a5f7bb1506bfd7ab24d4ba26",
                      "_blank"
                    );
                  } else if (globalChainID === 11155111) {
                    window.open(
                      "https://app.superfluid.finance/token/sepolia/0x783fdeab6951504c4601184587aafed01511ed24",
                      "_blank"
                    );
                  } else if (globalChainID === 137) {
                    window.open(
                      "https://app.superfluid.finance/token/polygon/0xf1e073d53af781966f23b1a3b2d9e67cbba69b92",
                      "_blank"
                    );
                  } else {
                    // Nothing
                  }
                }}
              >
                <span className="h-20 f-center">
                  <img
                    src={icons.superfluid}
                    alt="superfluid"
                    className="fit-image"
                  />
                </span>
                <span className="text-16-400">Superfluid</span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ApolloProvider client={client}>
            <Stream tokenBalance={tokenBalance} globalChainID={globalChainID} />
          </ApolloProvider>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default TransactionAndStream;
